import styled from 'styled-components';

export const GoStreakWrapper = styled.div(
  props => `
      background:${props.theme.colors.goWhite.base};
      position: relative;
      border-radius: 50%;

    width: 32px;
    height: 32px;
    .circle-background,
.circle-progress {
  fill: none;
}

.circle-background {
  stroke: #ffdcd8;
}

.circle-progress {
  stroke: #FF6D38;
  stroke-linecap: round;
  stroke-linejoin: round;
}


.iconWrapper {
    width: 32px;
    height: 32px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);

    display: flex;
    align-items: center;
    justify-content: center;
}

.textWrapper {
    background: linear-gradient(315deg, #FF6D38 0%, #FF3A5C 100%);
    border-radius: 0.4rem;
    padding: 0.1rem 0.6rem;
    font-weight: 700;
    font-size: 1.1rem;
    line-height: 1.2rem;
    color: #FFFCFA;
    bottom: -5px;
    position: absolute;
    left: 1px;
}
        `,
);
